module.exports = __webpack_public_path__ + "static/media/cesar.2142eea1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/SectionOne/illus/cesar.svg
// module id = 148
// module chunks = 0